import styled from "styled-components";

export const HeaderWelcomeButtonsContainerDefaultBox = styled.div`
  .login_buttons {
    display: flex;
    flex-direction: row-reverse;
  }
`;
